import { Button } from "@mantine/core";

import { usePostApi } from "../../../../../hooks";
import { type Stamp } from "../../../../../interfaces/Stamps";
import { StyledTd, StyledTr } from "../../../../../styled";
import { Notification } from "../../../../../utils/Notification";
import { getYachtId } from "../../../../../utils";
import { useDispatch } from "../../../../../redux/hooks";
import { setStampsModalProps } from "../../../../../redux/slices/generatorSlice";
import ConfirmationButton from "src/components/shared/ConfirmationButton/ConfirmationButton";

interface Props extends Stamp {
  refetchStamps: () => void;
  handleOpenHistoryModal: () => void;
}

const ShipsStampsListItem = ({
  stampid,
  logbooks,
  name,
  data,
  refetchStamps,
  handleOpenHistoryModal,
}: Props) => {
  const dispatch = useDispatch();

  const { post, isLoading } = usePostApi();

  const deleteRow = async () => {
    await post({
      request: "remove-stamp",
      body: { params: { yachtid: getYachtId(), stampid } },
      onSuccess: () => {
        Notification("Success", "Stamp has been successfully removed", "green");
        refetchStamps();
      },
    });
  };
  const handleEdit = () => {
    dispatch(
      setStampsModalProps({
        opened: true,
        stampid,
      }),
    );
  };
  return (
    <StyledTr key={stampid}>
      <StyledTd style={{ textAlign: "center", maxWidth: "200px" }}>
        {name}
      </StyledTd>
      <StyledTd style={{ textAlign: "center", maxWidth: "120px" }}>
        <img src={`data:image/png;base64, ${data}`} alt="" width="100" />
      </StyledTd>
      <StyledTd>{logbooks.join(", ")}</StyledTd>
      <StyledTd>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          <Button onClick={handleEdit} variant="outline" size="xs">
            Edit
          </Button>
          <Button onClick={handleOpenHistoryModal} variant="outline" size="xs">
            History
          </Button>
          <ConfirmationButton
            modalText="Are you sure you wish to remove this stamp?"
            onConfirm={deleteRow}
            buttonProps={{
              size: "xs",
              variant: "outline",
              color: "red",
            }}>
            Delete
          </ConfirmationButton>
        </div>
      </StyledTd>
    </StyledTr>
  );
};
export default ShipsStampsListItem;
